import { defineStore } from 'pinia'
import { flatten } from 'lodash'
import WeatherWarningRepository from '@/repositories/weather-warning-repository'
import { Alert, Area, ALERT_KIND_STATUSES } from '@/models/WeatherWarning'
import repositoryFactory from '@/factories/repository-factory'

const storeKey = 'weatherWarning'

type Store = {
  weatherWarningData: Alert[]
}

export const useWeatherWaringStore = defineStore(storeKey, {
  state: () =>
    ({
      weatherWarningData: [] as Alert[],
    } as Store),

  actions: {
    async fetch(areaList: Area[]) {
      const repository = (await repositoryFactory.create()).get(storeKey) as WeatherWarningRepository

      this.weatherWarningData = await Promise.all(areaList.map(area => repository.get(area.code.toString())))
    },
  },

  getters: {
    maxAlertLevel: state => {
      const warnings = flatten(state.weatherWarningData.map(value => value.kinds))
      const levels = warnings
        .filter(w => w.status === ALERT_KIND_STATUSES.NEW || w.status === ALERT_KIND_STATUSES.CONTINUE)
        .map(w => w.level)
        .filter(w => w) as number[]

      if (levels.length == 0) {
        return 0
      }

      const maxLevel = Math.max(...levels)
      return `weather_warn${maxLevel}`
    },
  },
})
